function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.83 21.87h-.07a.501.501 0 01-.434-.496c0-.023.002-.045.004-.067v.003l2.48-18a.505.505 0 011-.143v.003l4.65 10.43 4.61-10.39a.506.506 0 111 .143V3.35l2.48 18a.5.5 0 01-.428.559h-.003a.51.51 0 01-.56-.427v-.003l-2.29-16.26-4.4 9.86a.5.5 0 01-.458.3h-.004a.5.5 0 01-.457-.297l-.001-.003-4.39-9.86-2.24 16.22a.5.5 0 01-.49.43zm-2.48 0h-.07a.501.501 0 01-.43-.563v.003l2.48-18a.506.506 0 111 .143V3.45l-2.48 18a.5.5 0 01-.494.42h-.007zm-2.47 0h-.07a.501.501 0 01-.434-.496c0-.023.002-.045.004-.067v.003l2.48-18a.49.49 0 01.563-.429H4.42a.501.501 0 01.434.496c0 .023-.002.045-.004.067v-.003l-2.48 18a.5.5 0 01-.49.43z"
});

function SvgMd(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "md.33efc.svg";
export { SvgMd as ReactComponent };